export enum PageMode {
  ATTACHMENTS = 'Attachments',
  COMMENTS = 'Comments',
  COPY = 'Copy',
  DELETE = 'Delete',
  EDIT = 'Edit',
  NEW = 'New',
  VIEW = 'View',
}
